export default {
  peopleCount: 0,
  headerHeight: 40,
}
